export interface ExportColumn {
  key: string;
  label: string;
  disabled?: boolean;
}

export interface ExportColumnGroup {
  title: string;
  columns: ExportColumn[];
}

export const PEOPLE_EXPORT_GROUPS: ExportColumnGroup[] = [
  {
    title: 'Person Information',
    columns: [
      { key: 'full_name', label: 'Name' },
      { key: 'emails', label: 'Email', disabled: true },
      { key: 'job_title', label: 'Job Title' },
      { key: 'past_companies', label: 'Past Companies' },
      { key: 'phones', label: 'Phone' },
      { key: 'department', label: 'Department' },
      { key: 'social_link', label: 'Socials' },
      { key: 'location', label: 'Location' },
      // { key: 'industry', label: 'Industry' },
      { key: 'management_level', label: 'Management Level' },
      { key: 'decision_maker', label: 'Decision Maker' },
      { key: 'job_changed_on', label: 'Job Changed On' },
      { key: 'skills', label: 'Skills' },
      {
        key: 'experience_at_current_company',
        label: 'Current Company Experience',
      },
      { key: 'total_experience', label: 'Years of Experience' },
      { key: 'active_experiences', label: 'Active Experiences' },
      { key: 'current_role_tenure_months', label: 'Tenure in Current Role' },
      { key: 'projected_base_salary_dollars', label: 'Projected Salary' },
      { key: 'education_degrees', label: 'Degree' },
      { key: 'institution_name', label: 'School' },
      { key: 'linkedin_followers_count', label: 'Followers' },
    ],
  },
  {
    title: 'Company Information',
    columns: [
      { key: 'company_name', label: 'Company Name' },
      { key: 'company_website', label: 'Company Website' },
      { key: 'company_size_range', label: 'Company Size' },
      { key: 'company_annual_revenue', label: 'Company Revenue' },
      { key: 'company_industry', label: 'Company Industry' },
      { key: 'company_founded_year', label: 'Company Founded Year' },
      { key: 'company_is_b2b', label: 'Is B2B' },
      { key: 'company_hq_location', label: 'Company HQ Location' },
      { key: 'company_domain', label: 'Company Domain' },
      { key: 'company_socials', label: 'Company Socials' },
      {
        key: 'company_last_funding_round_amount_raised',
        label: 'Funding Amount',
      },
      { key: 'company_last_funding_date', label: 'Funding Date' },
    ],
  },
];

export const COMPANY_EXPORT_GROUPS: ExportColumnGroup[] = [
  {
    title: 'Basic Information',
    columns: [
      { key: 'company_name', label: 'Company Name' },
      { key: 'company_emails', label: 'Company Email' },
      { key: 'company_phone_numbers', label: 'Company Phone' },
      { key: 'social_urls', label: 'Socials' },
      { key: 'founded_year', label: 'Founded Year' },
      { key: 'industry', label: 'Industry Type' },
      { key: 'is_b2b', label: 'Is B2B' },
      { key: 'ownership_status', label: 'Ownership Status' },
      { key: 'description_enriched', label: 'Company Description' },
      { key: 'followers_count_linkedin', label: 'LinkedIn Followers' },
    ],
  },
  {
    title: 'Employees & Operations',
    columns: [
      { key: 'company_size_range', label: 'Employee Count' },
      {
        key: 'employees_count_by_department',
        label: 'Employee Count by Department',
      },
      {
        key: 'employees_count_by_seniority',
        label: 'Employee Count by Designation',
      },
      { key: 'active_job_postings_count', label: 'Active Job Posting Count' },
      { key: 'key_executive_departures', label: 'Executive Departure' },
      { key: 'key_executive_arrivals', label: 'Executive Arrival' },
      { key: 'competitors', label: 'Competitors Company' },
    ],
  },
  {
    title: 'Financial & Funding',
    columns: [
      { key: 'last_funding_round_name', label: 'Last Funding Round' },
      { key: 'last_funding_round_amount_raised', label: 'Last Raised Amount' },
      { key: 'last_funding_round_announced_date', label: 'Last Funding Date' },
      { key: 'funding_rounds', label: 'Funding Rounds' },
      { key: 'ebit', label: 'Ebit' },
      { key: 'ebitda', label: 'Ebitda' },
      { key: 'ebitda_margin', label: 'Ebitda Margin' },
      { key: 'ebit_margin', label: 'Ebit Margin' },
      { key: 'gross_profit', label: 'Gross Profit' },
      { key: 'gross_profit_margin', label: 'Gross Profit Margin' },
      { key: 'net_income', label: 'Net Income' },
      { key: 'total_operating_expense', label: 'Total Operating Expense' },
      { key: 'cost_of_goods_sold', label: 'Cost of Goods Sold' },
      { key: 'stock_information', label: 'Stock Information' },
    ],
  },
  {
    title: 'Digital & Technology',
    columns: [
      { key: 'sic_codes', label: 'SIC Codes' },
      { key: 'naics_codes', label: 'NAICS Codes' },
      { key: 'categories_and_keywords', label: 'Categories and Keywords' },
      { key: 'technologies_used', label: 'Technologies' },
      { key: 'total_website_visits_monthly', label: 'Website Visitor Count' },
      {
        key: 'visits_breakdown_by_country',
        label: 'Website Visitor Count by Country',
      },
      {
        key: 'visits_breakdown_by_gender',
        label: 'Website Visitor Count by Gender',
      },
      { key: 'product_reviews_score', label: 'Product Review Score' },
      {
        key: 'employee_reviews_score',
        label: 'Employee Review Score',
      },
    ],
  },
];

export const COMPANY_REQUIRED_KEYS = [
  'company_name',
  'company_emails',
  'company_phone_numbers',
];
